import { TrackSegment } from '@com/components/timeline-panel/types'
import {
  IvAssetSegment,
  IvComponentSegment,
  IvSegment,
  IvSegmentAudio,
  IvSegmentFreeze,
  IvSegmentHand,
  IvSegmentImage,
  IvSegmentLoop,
  IvSegmentText,
  IvSegmentVideo,
  IvTrack,
} from '../types'
import { IvSegmentType, IvTrackType } from '../enums'
import { resolveSegmentFramesIfGap } from '@com/components/timeline-panel/utils/segment'

export function isIvSegment(segment: TrackSegment): segment is IvSegment {
  return true
}
export function isSupportRelativedIv(
  segment: IvSegment,
): segment is IvSegmentText | IvSegmentHand | IvSegmentImage {
  return [IvSegmentType.Text, IvSegmentType.Hand, IvSegmentType.Image].includes(
    segment.type,
  )
}

export function isSegmentFreeze(
  segment: IvSegment,
): segment is IvSegmentFreeze {
  return segment.type === IvSegmentType.Freeze
}

export function isSegmentLoop(segment: IvSegment): segment is IvSegmentLoop {
  return segment.type === IvSegmentType.Loop
}

export function isSegmentVideo(segment: IvSegment): segment is IvSegmentVideo {
  return segment.type === IvSegmentType.Video
}

export function isSegmentAudio(segment: IvSegment): segment is IvSegmentAudio {
  return segment.type === IvSegmentType.Audio
}

export function isSegmentImage(segment: IvSegment): segment is IvSegmentImage {
  return segment.type === IvSegmentType.Image
}

export function isAssetSegment(segment: IvSegment): segment is IvAssetSegment {
  return (
    isSegmentVideo(segment) ||
    isSegmentAudio(segment) ||
    isSegmentImage(segment)
  )
}

export function isSegmentIv(segment: IvSegment): segment is IvComponentSegment {
  const types: IvComponentSegment['type'][] = [
    IvSegmentType.Freeze,
    IvSegmentType.Hold,
    IvSegmentType.Loop,
  ]

  return types.includes(segment.type as any)
}

export function getSceneSegments(
  sceneUuid: IvSegment['sceneUuid'],
  tracks: IvTrack[],
): IvSegment[] {
  return tracks.reduce<IvSegment[]>((segments, t) => {
    t.segments.forEach((s) => {
      if (s.sceneUuid === sceneUuid) {
        segments.push(s)
      }
    })

    return segments
  }, [])
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getIvRelativedSegments(
  iv: IvComponentSegment,
  tracks: IvTrack[],
) {
  const sceneSegments = getSceneSegments(iv.sceneUuid, tracks)

  return sceneSegments
    .filter(isSupportRelativedIv)
    .filter(
      (s) =>
        s.start === iv.start &&
        resolveSegmentFramesIfGap(s) === resolveSegmentFramesIfGap(iv),
    )
}
/**
 * 获取元件附属的互动元件
 * @param segment 指定元件
 * @returns 互动元件
 */
export function getRelativedIv(
  segment: Exclude<IvSegment, IvComponentSegment>,
  tracks: IvTrack[],
): IvComponentSegment | null {
  if (segment.type === IvSegmentType.Video) {
    return null
  }

  for (let index = 0; index < tracks.length; index++) {
    const track = tracks[index]
    const segments =
      track?.type === IvTrackType.Iv && track?.segments ? track.segments : []

    for (let i = 0; i < segments.length; i++) {
      const s = segments[i]

      if (
        s &&
        s.start === segment.start &&
        resolveSegmentFramesIfGap(s) === resolveSegmentFramesIfGap(segment)
      ) {
        return s
      }
    }
  }

  return null
}
